import React from 'react'
import PropTypes from 'prop-types'
import injectSheet from 'react-jss'
import { PanoPlayer } from 'aria-viewer/common/components/PanoPlayer'
import classNames from 'classnames'
import compose from 'recompose/compose'
import pure from 'recompose/pure'
import { Preload } from 'react-preloaded'

const styleSheet = theme => ({
    panoTitleDescriptionContainer: {
        position: 'absolute',
        bottom: '0',
        color: 'white',
        background: 'linear-gradient(to top, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0))',
        pointerEvents: 'none',
    },
    panoTitle: {
        fontSize: '36px',
        lineHeight: '46px',
        fontWeight: '500',
        textShadow: '0 6px 20px rgba(0, 0, 0, 0.4), 0 2px 4px rgba(0, 0, 0, 0.5)',
        '& > p > a': {
            color: 'white',
            textDecoration: 'underline',
            '&:hover': {
                textDecorationColor: 'blue',
            },
        },
    },
    panoDescription: {
        fontSize: '15px',
        lineHeight: '22px',
        textShadow: '0 2px 4px rgba(0, 0, 0, 0.5)',
        '& > p > a': {
            color: 'white',
            textDecoration: 'underline',
            '&:hover': {
                textDecorationColor: 'blue',
            },
        },
    },
})

const style = injectSheet(styleSheet)

const panoPlayer = ({ classes, title, description, sourceURL, ...otherProps }) => (
    <PanoPlayer sourceURL={sourceURL} {...otherProps}>
        <div className={classNames(classes.panoTitleDescriptionContainer, 'panoTitleDescriptionContainer')}>
            <h1 className={classes.panoTitle} dangerouslySetInnerHTML={{ __html: title }} />
            <p className={classes.panoDescription} dangerouslySetInnerHTML={{ __html: description }} />
        </div>
    </PanoPlayer>
)

const PanoPlayerWithTitleDescription = ({
    classes,
    title,
    description,
    smallSourceURL,
    largeSourceURL,
    ...otherProps
}) => (
    <Preload
        loadingIndicator={panoPlayer({ classes, title, description, sourceURL: smallSourceURL, ...otherProps })}
        images={[largeSourceURL]}
    >
        {panoPlayer({ classes, title, description, sourceURL: largeSourceURL, ...otherProps })}
    </Preload>
)

PanoPlayerWithTitleDescription.propTypes = {
    title: PropTypes.string,
    description: PropTypes.string,
}

PanoPlayerWithTitleDescription.defaultProps = {
    title: '',
    description: '',
    fov: 100,
}

export default compose(
    style,
    pure
)(PanoPlayerWithTitleDescription)
